import { AnchorElementKind as ButtonKind } from "../Anchor";
export { ButtonKind };
export var ButtonColor;

(function (ButtonColor) {
  ButtonColor["PRIMARY"] = "primary";
  ButtonColor["SECONDARY"] = "secondary";
  ButtonColor["TERTIARY"] = "tertiary";
})(ButtonColor || (ButtonColor = {}));

export var ButtonSizes;

(function (ButtonSizes) {
  ButtonSizes["SMALL"] = "small";
  ButtonSizes["MEDIUM"] = "medium";
})(ButtonSizes || (ButtonSizes = {}));

export var IconPosition;

(function (IconPosition) {
  IconPosition["LEFT"] = "left";
  IconPosition["RIGHT"] = "right";
})(IconPosition || (IconPosition = {}));